import {fetch, postB, postQ, get} from 'urlconf/index'
import global from '../config/global'
import md5 from 'js-md5'
import {isnull, localGet, localSave} from "../utils/tools";
import version from "vuex/dist/vuex.mjs";
import {postQB} from "../apiconfig";

export default {
  loadVoiceAnchorInfo(roomId,anchorId,successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return get('api/VoiceChatRoom/GetVoiceChatRoomAnchorInfo', ['session=' + localGet(global.key.session),'roomId='+roomId,'anchorId='+anchorId], function (data) {
      successCallback && successCallback(data,vueObj)
    },  function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  loadVoiceUserInfo(roomId,userId,successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return get('api/VoiceChatRoom/GetVoiceChatRoomUserInfo', ['session=' + localGet(global.key.session),'roomId='+roomId,'userId='+userId], function (data) {
      successCallback && successCallback(data,vueObj)
    },  function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  joinVoiceChatRoomByHostId(hostId, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return postQ('api/VoiceChatRoom/JoinRoomByRoomId', ['session=' + localGet(global.key.session), 'roomId=' + hostId], function (data) {
      successCallback && successCallback(data,vueObj)
    },  function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  leaveVoiceChatRoom(roomId, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return postQ('api/VoiceChatRoom/LeaveRoom', ['session=' + localGet(global.key.session), 'roomId=' + roomId], function (data) {
      successCallback && successCallback(data)
    },  function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  getRoomInfo(roomId, successCallback = null, failCallBack = null, vueObj) {
    return get('api/VoiceChatRoomV2/GetRoomInfo', ['session=' + localGet(global.key.session), 'roomId=' + roomId], function (data) {
      successCallback && successCallback(data,vueObj)
    }, function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, false, false)
  },
  userSendGift(roomId,giftId,anchorId, successCallback = null, failCallBack = null, vueObj) {
    return postQ('api/VoiceChatRoomV2/UserSendGift', ['session=' + localGet(global.key.session), 'roomId=' + roomId,'giftId='+giftId,'anchorId='+anchorId], function (data) {
      successCallback && successCallback(data,vueObj)
    },  function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, false, false)
  },
  sendTextMsg(roomId,content, successCallback = null, failCallBack = null, vueObj) {
    return postQ('api/VoiceChatRoom/SendTextMsg', ['session=' + localGet(global.key.session), 'roomId=' + roomId,'content='+encodeURIComponent(content)], function (data) {
      successCallback && successCallback(data,vueObj)
    },  function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, false, false)
  },
  applyToBeBoss(roomId,successCallback=null,failCallback=null,vueObj){
    return postQ('api/VoiceChatRoomV2/UserApplyBeBoss', ['session=' + localGet(global.key.session), 'roomId=' + roomId], function (data) {
      successCallback && successCallback(data,vueObj)
    },  function (code, msg) {
      failCallback&&failCallback(code,msg,vueObj)
    }, '/webApp', vueObj, true, true)
  },
  bossPutOffMic(roomId,successCallback=null,failCallback=null,vueObj){
    return postQ('api/VoiceChatRoomV2/BossPutOffMic', ['session=' + localGet(global.key.session), 'roomId=' + roomId], function (data) {
      successCallback && successCallback(data,vueObj)
    },  function (code, msg) {
      failCallback&&failCallback(code,msg,vueObj)
    }, '/webApp', vueObj, true, true)
  },
  takeAnchor(roomId,anchorId,giftId,successCallback=null,failCallback=null,vueObj){
    postQ('api/VoiceChatRoomV2/TakeAnchor', ['session=' + localGet(global.key.session), 'anchorId='+anchorId,'giftId=' + giftId, 'roomId=' + roomId], function (data) {
      successCallback && successCallback(data,vueObj)
    },  function (code, msg) {
      failCallback&&failCallback(code,msg,vueObj)
    }, '/webApp', vueObj, true, true)
  },
  setGiftViewed(title, successCallback = null, failCallBack = null, vueObj) {
    return postQ('api/VoiceChatRoom/SetGiftViewed', ['session=' + localGet(global.key.session), 'title=' + title], function (data) {
      successCallback && successCallback(data,vueObj)
    },  function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, false, false)
  },
  reportRoom(roomId,report, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return postQB('api/VoiceChatRoom/ReportRoom', ['session=' + localGet(global.key.session), 'roomId=' + roomId],report, function (data) {
      successCallback && successCallback(data,vueObj)
    }, function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
}



// WEBPACK FOOTER //
// ./src/api/voice-api.js